import { Text } from '@lmn/design-system';
import styled, { keyframes } from 'styled-components';

const taxesTooltipSlideIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.3);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

/* Outer wrapper: column, right-aligned, 269px (from Figma) */
export const TaxesIncludedTooltipWrapper = styled.div`
  animation: ${taxesTooltipSlideIn} 0.5s ease-in-out;
  transform-origin: top right;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

/* Small caret pointing upward, right-aligned with 8px margin from right edge */
export const TaxesIncludedTooltipCaret = styled.div`
  margin-right: 8px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid ${({ theme }) => theme.kallisto.color.background.static.backgroundNeutralContrast};
`;

/* Dark content bubble */
export const TaxesIncludedTooltipContent = styled.div`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundNeutralContrast};
  border-radius: 4px;
  padding: 8px 12px;
  width: 100%;
  position: relative;
`;

/* Row inside content: deposit icon + text, with right padding for close button */
export const TaxesIncludedTooltipInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding-right: 40px;
`;

export const TaxesIncludedTooltipImage = styled.img`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
`;

export const TaxesIncludedTooltipTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TaxesIncludedTooltipText = styled(Text).attrs({ variant: 'BodySmall' })`
  color: white;
  white-space: nowrap;
`;

/* Absolutely positioned close button at top-right corner of the content bubble */
export const TaxesIncludedTooltipCloseButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: white;
  padding: 0;
`;
